import axios from '@/api/axios';
import { gql } from '@/api/utils';

export default {
  async fetchOrderPaymentScreenContext({ orderId }) {
    try {
      const query = gql`
        query orderPaymentScreenContextQuery($orderId: ID!) {
          orderPaymentScreenContextQuery(orderId: $orderId) {
            termsOfServiceAndPrivacyPolicyOptInCopy
            marketingCommunicationOptInCopy
            storedCreditCardMessage
            successRedirectUrl
          }
        }
      `;

      const variables = { orderId };
      const { orderPaymentScreenContextQuery: screenContext } = await axios.post(`/`, { query, variables });

      return screenContext;
    } catch (error) {
      throw new Error(error?.message?.[0]?.message || error?.message || 'There was an unexpected error.');
    }
  },
};
